<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>Rompendo fronteiras</h2>
          <p>
            A empresa dá início ao seu processo de internacionalização ao
            adquirir as operações da <strong>Swift Armour</strong> na Argentina,
            maior e mais reconhecida marca do setor naquele país. Com esse
            movimento, a Companhia aumenta sua participação no negócio de
            industrializados de carne bovina.
          </p>
          <img
            src="../assets/img/2005/2005-2.jpg"
            alt=""
            @click="showMultiple(0)"
          />
        </div>
        <div class="formato__warpper__item--black">
          <h2>Surge o Guia Alimentar da População Brasileira</h2>
          <p>
            Lançado pelo governo federal em 2005, o
            <strong>Guia Alimentar</strong> da
            <strong>População Brasileira</strong> mostrou a transformação nos
            hábitos alimentares da nossa população, que trocou o feijão e ovo
            por carne e leite.
          </p>

          <div class="images">
            <img
              src="../assets/img/2005/2005-1.png"
              alt=""
              @click="
                openLink(
                  'https://acervo.estadao.com.br/publicados/2005/10/11/g/20051011-40901-nac-16-ger-a17-not-kkaaqxq.jpg'
                )
              "
            />
            <span
              ><i class="icon-eye"></i
              ><strong>clique nas imagens para ampliar</strong></span
            >
          </div>
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from './Ano.vue';
import VueEasyLightbox from 'vue-easy-lightbox';
import { defineComponent } from 'vue';

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ['ano'],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, '_blank');
    },
    showMultiple(index) {
      this.imgsRef = [
        {
          src: require('@/assets/img/2005/2005-1-full.jpg'),
          title: '2005 - Aquisição da Swift na Argentina.',
        },
      ];
      this.indexRef = index; // index of imgList
      this.onShow();
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 100px;
    display: grid;
    grid-template-columns: 488px 525px;
    justify-content: space-between;
    gap: 10px;
    @include media('<=desktop') {
      grid-template-columns: 1fr;
    }
  }
  &__warpper {
    position: relative;

    &__item {
      position: relative;
      @include media('<=desktop') {
        padding: 20px;
      }
      &--image {
        display: grid;
        position: relative;
        grid-template-columns: 1fr 1fr;
        max-height: 705px;
        padding-top: 26px;
        margin-left: -110px;

        .span2 {
          grid-column: span 2;
          margin-top: 20px;
        }
        .fistItem {
          grid-column: 2;
          margin-left: -100px;
        }

        .terceiroItem {
          margin-top: 30px;
          margin-left: 20px;
        }
        .negativo {
          margin-left: -90px;
          margin-top: auto;
        }
      }
      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }
      img {
        cursor: pointer;
      }

      &--black {
        margin-left: 5rem;
        @include media('<=desktop') {
          margin: 0;
          background: url('../assets/img/2005/fundo.jpg');
          padding: 40px 20px;
        }
        span {
          width: 65px;
          color: color(cBLue6);
          display: block;
          strong {
            color: color(cBlue5);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cBLue6);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
        img {
          margin-top: 30px;
          cursor: pointer;
          margin-left: -20px;

          &:nth-child(2) {
            margin-left: auto;
            display: block;
            margin-top: -100px;
          }
        }
        p {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
          max-width: 250px;
        }
        h2 {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          max-width: 371px;
          margin-block: 15px;
          max-width: 250px;
        }
        blockquote {
          color: color(cBlue);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          position: relative;
          max-width: 370px;
          margin: 10px auto;
          &::before {
            content: '\e901';
            font-family: 'icomoon' !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 17px;
          }
        }
      }
    }
    &::after {
      content: '';
      background: url('../assets/img/2005/fundo.jpg');
      width: 45%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media('<=desktop') {
        display: none;
      }
    }
  }
}
</style>
